import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
import(/* webpackMode: "eager" */ "/app/public/css/0_bootstrap.min.css");
import(/* webpackMode: "eager" */ "/app/public/css/2_inner.css");
import(/* webpackMode: "eager" */ "/app/public/css/1_home.css");
import(/* webpackMode: "eager" */ "/app/public/css/3_all.css");
import(/* webpackMode: "eager" */ "/app/public/css/4_swiper8.min.css");
import(/* webpackMode: "eager" */ "/app/public/css/5_home.css");
import(/* webpackMode: "eager" */ "/app/public/css/6_common_style.css");
import(/* webpackMode: "eager" */ "/app/public/css/7_custom.css");
import(/* webpackMode: "eager" */ "/app/src/element/common/ConfigProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/CookieConsent.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/GoogleFontPreload.tsx");
import(/* webpackMode: "eager" */ "/app/src/element/common/RecaptchaProviderWrapper.tsx")